"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    stroke: props.color || "#1A61A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.516 9.818v.532H7.172v-.588c0-.345.054-.674.161-.987.107-.313.306-.674.595-1.085.336-.476.565-.887.686-1.232a3.27 3.27 0 00.182-1.092c0-.336-.065-.581-.196-.735-.13-.154-.322-.231-.574-.231-.252 0-.443.077-.574.231-.13.154-.196.399-.196.735V6.43H5.8v-.966c0-.793.191-1.402.574-1.827.383-.425.943-.637 1.68-.637.747 0 1.314.212 1.701.637.387.425.581 1.034.581 1.827 0 .43-.077.842-.231 1.239-.154.397-.418.842-.791 1.337-.299.401-.506.735-.623 1.001a1.928 1.928 0 00-.175.777zm.07 1.638v1.484H7.102v-1.484h1.484z",
    fill: props.color || "#1A61A7"
  }));
}

var _default = SvgHelp;
exports["default"] = _default;